import React, { createRef } from 'react';
import Modal from 'react-responsive-modal';
import stylesRV from '../RateView.module.css';

import ApiResponse from '../../../components/message/ApiResponse';

import { getCurrentResource } from '../../../util/tools';
import { getButtonMode } from '../../../util/localStorage';
import {
	ACTION_PROVIDER_LOAD_AGGREGATOR_LIST_API_URL, 
	USER_PROFILE_API_URL, ENTITY_EMAIL_LIST_API_URL, performApiRequest 
} from '../../../util/restapi';

import sendMessageIcon from '../../../assets/icons/png24x24/send_message.png';

const FORM_STATE_GET_DATA = 'd';
const FORM_STATE_WAITING = 'w';
const FORM_STATE_COMPLETE = 'c';

class ButtonSendEmail extends React.Component {
	
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.button.ButtonSendEmail;
		this.refModal = createRef();
		this.rateView = props.holder;
		this.state = {
			isModalOpen: false,
		}
	}

	openModal = async () => {
		await this.refModal.current.init();
		this.setState({ isModalOpen: true });	
	}
	closeModal = () => {
		this.setState({ isModalOpen: false });	
	}
	
	render() {
		if( this.props.holder.props.rvOptions.hideButtonSendEmail )
			return null;
		let buttonStyle = this.props.buttonStyle ? this.props.buttonStyle : {};
		let buttonHtml = null; 
		if( getButtonMode() == 'icon' ) {
			buttonHtml = (
				<button 
					type="button"
					className={stylesRV.buttonToolbarIcon} style={buttonStyle} 
					onClick={this.openModal} 
					title={this.resource.buttonSendEmailTooltip}
				>
					<img src={sendMessageIcon} />
				</button>
			);
		} else {
			buttonHtml = (
				<button 
					type="button"
					className={stylesRV.buttonToolbarText} style={buttonStyle} 
					onClick={this.openModal} 
					title={this.resource.buttonSendEmailTooltip}
				>
					{this.resource.buttonSendEmail}
				</button>
			);
		}
	
		return (
			<React.Fragment>
				{buttonHtml}
				<SendEmailModal ref={this.refModal}
					isModalOpen={this.state.isModalOpen} close={this.closeModal} 
					holder={this} 
				/>
			</React.Fragment>
		);
	}
	
}

class SendEmailModal extends React.Component {

	constructor(props) {
		super(props);
		this.rateView = props.holder.rateView;
		this.recipientList = [];
		this.request = {
			classId: '',
			listMarked: [],
			querySelected: null, 
			mode: 'marked',
			subject: '',
			from: '',
			email: '',
			recipientId: 0,
		}
		this.state = {
			dirtyCount: 0,
			formState: FORM_STATE_GET_DATA
		};
		
	}
	init = async () => {
		this.recipientList = [{id: 0, card: ''}];
		let response = await performApiRequest( ACTION_PROVIDER_LOAD_AGGREGATOR_LIST_API_URL, {} );
		if( ! response.success ) {
			this.setState({formState: FORM_STATE_COMPLETE});
			return;
		}
		for(let r of response.list) {
			this.recipientList.push( r );
		}

		response = await performApiRequest( USER_PROFILE_API_URL, {} );
		if( ! response.success ) {
			this.setState({formState: FORM_STATE_COMPLETE});
			return;
		}
		let from = '';
		if( response.data.user && response.data.user.contact && response.data.user.contact.email) {
			from = response.data.user.contact.email;
		}
		
		this.apiResponse = { message: '', log: ''};
		this.request = {
			classId: this.rateView.formInfo.masterClass,
			listMarked: this.rateView.getSelectedIds(),
			querySelected: this.rateView.query, 
			mode: 'marked', // marked, selected
			subject: '',
			from: from,
			email: '',
			recipientId: 0,
		}
		this.setState({formState: FORM_STATE_GET_DATA});
	}
	
	handleInputEdit = (e) => {
		const {name, value} = e.target;
		if( name == 'mode' ) {
			this.request.mode = value;
		} else if( name == 'from' ) {
			this.request.from = value;
		} else if( name == 'subject' ) {
			this.request.subject = value;
		} else if( name == 'email' ) {
			this.request.email = value;
		} else if( name == 'provider' ) {
			this.request.recipientId = value;
		}
		this.setState({dirtyCount: this.state.dirtyCount+1})
	}

	sendEmail = async () => {
		this.setState({formState: FORM_STATE_WAITING});
		this.apiResponse = await performApiRequest( ENTITY_EMAIL_LIST_API_URL, this.request );
		this.setState({formState: FORM_STATE_COMPLETE});
	}
	
	render() {
		let res = this.props.holder.resource;
		let divWaiting = null;
		let divMessage = null;
		let inputDisabled = this.state.formState != FORM_STATE_GET_DATA;
		if( this.state.formState == FORM_STATE_WAITING ) {
			divWaiting = <div style={{textAlign: 'center', padding: '7px'}}>{res.msgWait}</div>
		} else if( this.state.formState == FORM_STATE_COMPLETE ) {
			divMessage = <ApiResponse response={this.apiResponse} defaultMessage={res.msgSuccessfullySend} />
		}
		
		let listRecipentHtml = this.recipientList.map( (ref, index) => {
			return <option key={index} value={ref.id}>{ref.card}</option>
		} )
		
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal}
				closeOnOverlayClick={false} animationDuration={1}
			>
				<div>
					<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
						{res.modalTitle}
					</div>
					<div style={{marginTop: '10px', padding: '10px'}}>
						<div>
							<span style={{marginRight: '10px'}}>{res.labelMode}</span>
							<select name='mode' value={this.request.mode} onChange={this.handleInputEdit}>
								<option value='marked'>{res.optionMarked}</option>
								<option value='selected'>{res.optionSelected}</option>
							</select>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelFrom}</div>
							<input type='text'name='from' value={this.request.from} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelSubject}</div>
							<input type='text'name='subject' value={this.request.subject} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelRecipient}</div>
							<select name='provider'value={this.request.provider} onChange={this.handleInputEdit}>
								{listRecipentHtml}
							</select>
						</div>
					</div>
					{divWaiting}
					{divMessage}
					<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
						<button onClick={this.sendEmail} disabled={inputDisabled} title={'Tooltip'}>{res.buttonSend}</button>
					</div>
				</div>
			</Modal>
		);
	}
	
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};


export default ButtonSendEmail;
